export default __webpack_public_path__ + "images/quote.svg?b7395590af1dc998052d0a5e92f4b081";